import React from 'react';
import { makeStyles, Persona } from '@fluentui/react-components';
import { personaDetailsWrapper } from './UsersStyles';
import { IGraphUserObject } from '../../utils/types/Users';

const useStyles = makeStyles({
  avatarRing: {
    borderRadius: '50%',
    marginTop: '2px',
  },
});

interface IGraphUserBlockProps {
  graphUser: IGraphUserObject;
  userImage?: string;
}
const GraphUserBlock = (props: IGraphUserBlockProps): JSX.Element => {
  const { graphUser, userImage } = props;
  const classes = useStyles();
  if (!graphUser) {
    return <></>;
  }

  const { givenName, surname, displayName, jobTitle, officeLocation } =
    graphUser as IGraphUserObject;

  const initials = `${givenName ? givenName.charAt(0) : ''}${surname ? surname.charAt(0) : ''}`;

  return (
    <div className={personaDetailsWrapper}>
      <Persona
        name={displayName}
        secondaryText={jobTitle}
        tertiaryText={officeLocation}
        avatar={{
          size: 96,
          color: userImage ? 'neutral' : 'colorful',
          initials,
          image: userImage ? { src: userImage } : undefined,
          className: classes.avatarRing,
        }}
        size="huge"
        primaryText={{ style: { paddingTop: '35px', fontSize: '20px', marginLeft: '15px' } }}
      />
    </div>
  );
};
export default GraphUserBlock;
